import { PermissionService } from '@abp/ng.core';
import { Component, OnInit } from '@angular/core';
import { FeatureConstants } from 'src/core/constants/feature-constant';
import { PermissionConstants } from 'src/core/constants/permission-constant';
import { FeatureService } from 'src/core/services/feature/feature.service';

@Component({
  selector: 'ca-real-time-setting-group',
  templateUrl: './real-time-setting-group.component.html',
  styleUrls: ['./real-time-setting-group.component.scss'],
  standalone: false,
})
export class RealTimeSettingGroupComponent implements OnInit {
  activeTab: number = 1;

  realTimeFeatureEnabled: boolean = false;
  generativeQnAFeatureEnabled: boolean = false;
  virtualAgentIntegrationEnabled: boolean = false;
  voiceBiometricsIntegrationEnabled: boolean = false;
  performanceInsightsEnabled: boolean = false;
  virtualTranslatorEnabled: boolean = false;

  canManageSettings: boolean = false;

  constructor(
    private featureService: FeatureService,
    private permissionService: PermissionService
  ) {
    this.realTimeFeatureEnabled = this.featureService.isEnabled(FeatureConstants.RealTime);
    this.virtualAgentIntegrationEnabled = this.featureService.isEnabled(
      FeatureConstants.VirtualAgentIntegration
    );
    this.generativeQnAFeatureEnabled = this.featureService.isEnabled(FeatureConstants.GenerativeQA);
    this.voiceBiometricsIntegrationEnabled = this.featureService.isEnabled(
      FeatureConstants.VoiceBiometricsIntegration
    );
    this.performanceInsightsEnabled = this.featureService.isEnabled(
      FeatureConstants.PerformanceInsights
    );
    this.virtualTranslatorEnabled = this.featureService.isEnabled(
      FeatureConstants.VirtualTranslatorIntegration
    );
    this.canManageSettings = this.permissionService.getGrantedPolicy(
      PermissionConstants.SettingManagement
    );
  }

  ngOnInit(): void {
    if (this.virtualAgentIntegrationEnabled) {
      this.activeTab = 1;
    } else if (this.voiceBiometricsIntegrationEnabled) {
      this.activeTab = 2;
    } else if (this.generativeQnAFeatureEnabled) {
      this.activeTab = 3;
    } else if (this.performanceInsightsEnabled) {
      this.activeTab = 5;
    } else if (this.virtualTranslatorEnabled) {
      this.activeTab = 6;
    } else {
      this.activeTab = 7;
    }
  }
}
